module.exports = {
      id: "icons:linkedin-circle-usage",
      viewBox: "0 0 1024 1024",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#icons:linkedin-circle-usage",
      toString: function () {
        return this.url;
      }
    }